import { MeterAPI } from "../api";
import Helper from "../plugins/Helper/Helper";

export class Meter {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async getMeterByMarket(marketId, type, currencyCode) {
    const { data } = await MeterAPI.getMeterByMarket(marketId, type, currencyCode);
    return data.result.map(item => new Meter(item));
  }
  static async getMeterByArea(payload) {
    const { data } = await MeterAPI.getMeterByArea(payload);
    return data.result.map(item => new Meter(item));
  }
  static async getMeterByAreas(payload) {
    const { data } = await MeterAPI.getMeterByAreas(payload);
    return data.result.map(item => new Meter(item));
  }
  static async createMeter(payload) {
    const { data } = await MeterAPI.createMeter(payload);
    return new Meter(data.result);
  }

  static async updateMeter(payload) {
    const { data } = await MeterAPI.updateMeter(payload);
    return new Meter(data.result);
  }

  static async removeMeter(payload) {
    const { data } = await MeterAPI.removeMeter(payload);
    return new Meter(data.result);
  }
  static async getMeterDigitalByMarkets(marketIds) {
    const { data } = await MeterAPI.getMeterDigitalByMarkets(marketIds);
    return data.result.map(item => new Meter(item));
  }
  static async getMeterByIds(meterIds) {
    const { data } = await MeterAPI.getMeterByIds(meterIds);
    return data.result.map(item => new Meter(item));
  }

  static async getMeter(id) {
    const { data } = await MeterAPI.getMeter(id);
    return new Meter(data.result);
  }

  static async getMeterByProject(projectId, type, isDigitalMeter) {
    return Helper.queryMore(getData, { projectId, type, isDigitalMeter }, 1000)

    async function getData(d){
      const { data } = await MeterAPI.getMeterByProject(d);
      return data.result.map(item => new Meter(item));
    }
  }
}
